module.exports = __webpack_public_path__ + "ff5e86cd1f5e1e365e32f3619e44412c.MP3";